module["exports"] = ["com", "fr", "eu", "info", "name", "net", "org"];